var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3281 15.2061L23.0611 20.9391L20.9391 23.0611L15.2061 17.3281C11.3813 20.0495 6.10916 19.3858 3.07825 15.8013C0.0473458 12.2168 0.269102 6.90764 3.58837 3.58837C6.90764 0.269102 12.2168 0.0473458 15.8013 3.07825C19.3858 6.10916 20.0495 11.3813 17.3281 15.2061ZM10.0001 3.0001C6.13411 3.0001 3.0001 6.13411 3.0001 10.0001C3.00451 13.8643 6.13594 16.9957 10.0001 17.0001C13.8661 17.0001 17.0001 13.8661 17.0001 10.0001C17.0001 6.13411 13.8661 3.0001 10.0001 3.0001Z",
    fill: "#9BA3AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5a18ace1e053d2b7db1712e92f1b9cbc.svg";
export { ForwardRef as ReactComponent };